import React, {useState} from 'react'
import {PanelWrapper} from "./PanelWrapper";
import useGetEvents from "../../../hooks/api/useGetEventsBetween";
import {Card} from "../Card";
import {getEventCardFooter, isSelected, loadingSkeleton} from '../EntitySelectorModal.helpers'
import {DateTime} from "luxon";
import {formattedDateTime} from "../../../services/date";
import {Event} from "../../../types/Event";
import {EmptyState} from "../EmptyState";
import DateInput from "../../InsightControls/DateInput";
import {type SelectedItemsData} from "../../EntitySelector/EntitySelector.types";
import {ENTITY_TYPES} from "../../EntitySelector/EntitySelector.constants";

// Types ----

type EventsPanelProps = {
  onSelect: (event: Event) => void
  selectedItems: SelectedItemsData
  siteId?: number | null
  isMaxSelected?: boolean
  isMultiSite?: boolean
}

// Component ----

function EventsPanel({ onSelect, selectedItems, siteId, isMaxSelected, isMultiSite }: EventsPanelProps) {
  const [date, setDate] = useState<DateTime>(DateTime.now());

  const {data: events, isLoading} = useGetEvents({
    start: date.startOf('day'),
    end: date.endOf('day'),
    page: 1,
    perPage: 1000,
    siteId: siteId ?? null,
    typeId: null,
    params: { sort: 'starts_at' },
  });

  return (
    <PanelWrapper isLoading={isLoading}>
      <div className='flex flex-col gap-4'>
        <div className='w-full max-w-48'>
          <DateInput
            id='event-date'
            name='event-date'
            value={date}
            onChange={(date) => setDate(date)}
            maxDate={DateTime.now().plus({year: 2})}
          />
        </div>

        {isLoading ?
          loadingSkeleton :
          <>
            {!!events?.data?.length ? events?.data.map((event: Event) => {
                const selected = isSelected(event, ENTITY_TYPES.EVENT, selectedItems);

                return (
                  <Card
                    key={event.id}
                    onClick={() => onSelect(event)}
                    heading={event.name}
                    subheading={formattedDateTime(event.starts_at)}
                    footer={getEventCardFooter(event, isMultiSite)}
                    imageUrl={event.image?.preview_url}
                    active={selected}
                    disabled={isMaxSelected && !selected}
                  />
                )
              }) :
              <EmptyState />
            }
          </>
        }
      </div>
    </PanelWrapper>
  );
}

export {EventsPanel};